import { render, staticRenderFns } from "./noResults.vue?vue&type=template&id=35ec1c5f&"
import script from "./noResults.vue?vue&type=script&lang=js&"
export * from "./noResults.vue?vue&type=script&lang=js&"
import style0 from "./noResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports